import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgGuard = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.0439 4.05261L10.0001 2.38086L4.95628 4.05261C4.57626 4.17858 4.2456 4.4211 4.01126 4.74571C3.77692 5.07031 3.65083 5.46051 3.65088 5.86086V9.99419C3.65088 14.7713 9.49215 17.4094 9.74231 17.5193L9.96707 17.619L10.2007 17.5415C10.4521 17.4577 16.3493 15.4399 16.3493 9.99419V5.86086C16.3493 5.46051 16.2232 5.07031 15.9889 4.74571C15.7546 4.4211 15.4239 4.17858 15.0439 4.05261ZM10.282 11.2571C10.171 11.3688 10.0389 11.4574 9.8934 11.5176C9.7479 11.5779 9.59187 11.6087 9.43437 11.6082H9.41342C9.25271 11.6057 9.09418 11.5707 8.9474 11.5052C8.80062 11.4397 8.66864 11.3451 8.55945 11.2272L7.09532 9.7034L8.01151 8.82594L9.43628 10.3117L12.7258 7.02213L13.6236 7.91991L10.282 11.2571Z",
		fill: "#156EFF"
	})
});
const ForwardRef = forwardRef(SvgGuard);
export default ForwardRef;
